/**
 * AiDraftingNotice — inline notice shown next to the manual create-order
 * controls while the AI is still classifying the email ('drafting'), or
 * after it gave up / timed out ('failed').
 *
 * Non-blocking by design (same philosophy as the dup-PO warning): the CSR
 * can still create an order manually — the notice just stops the reflexive
 * race that produces empty duplicate shells.
 */
import styles from './AiDraftingNotice.module.css';

interface AiDraftingNoticeProps {
  state: 'drafting' | 'failed';
}

const AiDraftingNotice: React.FC<AiDraftingNoticeProps> = ({ state }) => {
  if (state === 'drafting') {
    return (
      <div className={styles.drafting} role="status">
        <span className={styles.spinner} aria-hidden="true" />
        <div>
          <div className={styles.title}>AI is drafting…</div>
          <div className={styles.detail}>
            This email is being processed. If it&apos;s an order, a draft will
            appear here within a couple of minutes — no need to create one
            manually.
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.failed} role="alert">
      <span className={styles.warnIcon} aria-hidden="true">&#9888;</span>
      <div>
        <div className={styles.title}>AI processing failed</div>
        <div className={styles.detail}>
          The AI couldn&apos;t finish this email (failed or timed out after 10
          minutes). Please review it and create any order manually.
        </div>
      </div>
    </div>
  );
};

export default AiDraftingNotice;
